import { getSelectedOptions } from 'utils';
import { DELIVERY_STATUS } from 'constants/ProductConstants';

const refineStatement = (shopOrder) => {
  const {
    created_at,
    cash_bill_info,
    delivery_address,
    final_delivery_price,
    parcel_service,
    payment_info,
    payment_serial_number,
    user,
  } = shopOrder;

  const list = parcel_service.reduce(
    (acc, cur, index) => {
      const { product, refund, delivery_status, discount_price } = cur;

      const item = {
        supplier: product.shop_information_name,
        name: product.product_name,
        option: getSelectedOptions(
          product.product_option,
          ' / ',
          (parents, child) => `${parents.option_title}: ${child.option_name}`
        ),
        thumbnail: product.thumbnail,
        num: product.num,
        originPrice: product.price,
        paymentPrice: product.product_final_price,
        discountPrice: discount_price,
        deliveryPrice: index === 0 ? final_delivery_price : 0,
        deliveryStatus: DELIVERY_STATUS[delivery_status].title,
      };

      // 취소/환불
      let key = '';
      if (refund?.length) {
        key = 'CANCEL';

        const [refundItem] = refund;
        item['refundAmount'] = refundItem.refund_amount;
        item['refundNum'] = refundItem.refund_num;
        item['refundDate'] = refundItem.refund_date;
        item['refundReason'] = refundItem.refund_reason;
        item['refundStatus'] = refundItem.refund_status;

        acc['CANCEL']['products'].push(item);
        acc['CANCEL']['totalRefundPrice'] += item.refundAmount;
        acc['CANCEL']['totalRefundNum'] += item.refundNum;
      } else if (delivery_status.includes('EXCHANGE')) {
        key = 'EXCHANGE';
        acc['EXCHANGE']['products'].push(item);
      } else if (delivery_status.includes('RETURN')) {
        key = 'RETURN';
        acc['RETURN']['products'].push(item);
      } else {
        key = 'ORDER';
        acc['ORDER']['products'].push(item);
      }

      acc[key]['totalNum'] += item.num;
      acc[key]['totalOriginPrice'] += item.originPrice;
      acc[key]['totalPaymentPrice'] += item.paymentPrice;
      acc[key]['totalDiscountPrice'] += item.discountPrice;

      return acc;
    },
    {
      ORDER: {
        products: [],
        totalNum: 0,
        totalOriginPrice: 0,
        totalPaymentPrice: 0,
        totalDiscountPrice: 0,
      },
      CANCEL: {
        products: [],
        totalOriginPrice: 0,
        totalRefundPrice: 0,
        totalRefundNum: 0,
        totalNum: 0,
        totalPaymentPrice: 0,
        totalDiscountPrice: 0,
      },
      EXCHANGE: {
        products: [],
        totalNum: 0,
        totalPaymentPrice: 0,
        totalDiscountPrice: 0,
      },
      RETURN: {
        products: [],
        totalNum: 0,
        totalPaymentPrice: 0,
        totalDiscountPrice: 0,
      },
    }
  );

  return {
    orderNo: payment_serial_number,
    orderDate: created_at,
    orderList: list.ORDER,
    cancelList: list.CANCEL,
    exchangeList: list.EXCHANGE,
    returnList: list.RETURN,

    paymentInfo: payment_info
      ? {
          id: payment_info.trno ?? payment_info.tid,
          ordno: payment_info.ordno ?? payment_info?.approvalNumb,
          date: payment_info.trddt
            ? `${payment_info.trddt} ${payment_info.trdtm}`
            : payment_info.tradeDateTime,
          method: payment_info.msg1
            ? payment_info.msg1
            : `${payment_info.purchaseCardType} ${payment_info.purchaseCardName}`,
          amount: payment_info.amt ?? payment_info.totalAmount,
        }
      : null,
    ...(cash_bill_info
      ? {
          cashBillInfo: {
            id: cash_bill_info.tid ?? cash_bill_info.trno,
            code: cash_bill_info.cashbillNumb,
            date: cash_bill_info.tradeDateTime,
            amount: cash_bill_info.totalAmount,
          },
        }
      : {}),
    ordererInfo: {
      id: user.user_id,
      gender: user.gender,
      name: user.user_name,
      phone: user.user_phone,
      email: user.user_email,
    },
    recipientInfo: {
      name: delivery_address.recipient_name ?? user.user_name,
      phone: delivery_address.recipient_phone ?? user.user_phone,
      postcode:
        delivery_address.recipient_postcode ??
        delivery_address?.forwarding_postcode,
      address:
        delivery_address.recipient_address ??
        delivery_address?.forwarding_address,
      detail:
        delivery_address.recipient_address_detail ??
        delivery_address?.forwarding_address_detail,
      memo: delivery_address.request,
    },
  };
};

export default refineStatement;
